var _excluded = ["children", "width", "height"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import $jbnEx$babelruntimehelpersesmextends from "@babel/runtime/helpers/esm/extends";
import { forwardRef as $jbnEx$forwardRef, createElement as $jbnEx$createElement } from "react";
import { Primitive as $jbnEx$Primitive } from "@radix-ui/react-primitive";

/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/
var $7e8f5cd07187803e$var$NAME = 'Arrow';
var $7e8f5cd07187803e$export$21b07c8f274aebd5 = /*#__PURE__*/$jbnEx$forwardRef(function (props, forwardedRef) {
  var children = props.children,
    _props$width = props.width,
    width = _props$width === void 0 ? 10 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 5 : _props$height,
    arrowProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/$jbnEx$createElement($jbnEx$Primitive.svg, $jbnEx$babelruntimehelpersesmextends({}, arrowProps, {
    ref: forwardedRef,
    width: width,
    height: height,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), props.asChild ? children : /*#__PURE__*/$jbnEx$createElement("polygon", {
    points: "0,0 30,0 15,10"
  }));
});
/*#__PURE__*/
Object.assign($7e8f5cd07187803e$export$21b07c8f274aebd5, {
  displayName: $7e8f5cd07187803e$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/
var $7e8f5cd07187803e$export$be92b6f5f03c0fe9 = $7e8f5cd07187803e$export$21b07c8f274aebd5;
export { $7e8f5cd07187803e$export$21b07c8f274aebd5 as Arrow, $7e8f5cd07187803e$export$be92b6f5f03c0fe9 as Root };